export default __webpack_public_path__ + "static/media/flag-singapore.2527bada.svg";